/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CcmAccountStatusEnum } from './ccmAccountStatusEnum';


/**
 * Response after updating account settings
 */
export interface CloudCostMgmtAccountUpdateResponse { 
    /**
     * AWS Account ID
     */
    account_id: string;
    /**
     * Cleanup enabled status
     */
    cleanup_enabled?: boolean;
    status?: CcmAccountStatusEnum;
}
export namespace CloudCostMgmtAccountUpdateResponse {
}


